<div class="accessory-management-container">

  <h3><span (click)="returnOnOfferSelection()" class="back-link" translate>T_OFFER_DATA_MANAGEMENT_BACK_BUTTON</span></h3>

  <div>
    <div class="titles">
      <p class="range-key" translate><span translate>T_OFFER_DATA_MANAGEMENT_LIST_OF_ACCESSORIES_OF_RANGE </span>{{selectedRange.nameKey}}</p>
    </div>
  </div>

  <div *ngIf="!isLoading">
    <button (click)="onClickAddCategoryButton()" class="btn btn-smart btn-gray"  translate>
      <span class="se-icons">action_add_stroke</span>T_ADD_ACCESSOR_CATEGORY
    </button>
    <button (click)="onClickAddAccessoryButton()" *ngIf="showAccessoryButtons()"  class="btn btn-smart btn-gray" translate>
      <span class="se-icons">action_add_stroke</span>T_ACCESSORY_ADD_BUTTON
    </button>
    <button  (click)="onClickAddAccessoryValueButton()" *ngIf="showAccessoryButtons()"  class="btn btn-smart btn-gray" translate>
      <span class="se-icons">action_add_stroke</span>T_ACCESSORY_VALUE_ADD_BUTTON
    </button>

    <div *ngFor="let category of accessoryCategories" class="category">
      <app-odm-manage-category
        (changeAccessoryOrderEvent)="onChangeAccessoryOrder($event)"
        (clickDeleteAccessoryButton)="onClickDeleteAccessoryButton($event)"
        (clickDeleteAccessoryValueButton)="onClickDeleteAccessoryValueButton($event)"
        (clickEditAccessoryButton)="onClickEditAccessoryButton($event)"
        (clickEditAccessoryValueButton)="onClickEditAccessoryValueButton($event)"
        (clickEditCategory)= "onClickEditCategory($event)"
        (clickMoveDownAccessoryValueEvent)="onClickMoveDownAccessoryValue($event)"
        (clickMoveUpAccessoryValueEvent)="onClickMoveUpAccessoryValue($event)"
        (onDeleteCategory)="deleteCategory($event)"
        [accessories]="accessories"
        [activeAccessory]="activeAccessory"
        [category]="category"
        [isExpanded]="category.id === activeCategory"
        [selectedRange]="selectedRange"
      >
      </app-odm-manage-category>
    </div>
  </div>

  <div *ngIf="isLoading" class="odm-left-column">
    <app-spinner [sizeClass]="'large'"></app-spinner>
  </div>
</div>


<app-odm-modal-category-name #addCategoryModal
                                               (onConfirmButton)="addCategory($event)"
                                               [isAddedCategory] = "true" >
</app-odm-modal-category-name>

<app-odm-edit-accessory-modal #addAccessoryModal
                                                (saveAccessory)="addAccessory($event)">
</app-odm-edit-accessory-modal>

<app-odm-edit-accessory-modal #editAccessoryModal
                                                (saveAccessory)="editAccessory($event)">
</app-odm-edit-accessory-modal>

<app-common-modal #deleteAccessoryModal (onClickYesButton)="deleteAccessory()" [description]="'T_DELETE_ACCESSORY_MODAL_MESSAGE' | translate"
                  [name]="'deleteAccessoryModal'" >
</app-common-modal>

<app-odm-edit-accessory-value-modal #addAccessoryValueModal
                                                    (saveAccessoryValue)="addAccessoryValue($event)">
</app-odm-edit-accessory-value-modal>

<app-odm-edit-accessory-value-modal #editAccessoryValueModal
                                                      (saveAccessoryValue)="editAccessoryValue($event)">
</app-odm-edit-accessory-value-modal>

<app-common-modal #deleteAccessoryValueModal (onClickYesButton)="deleteAccessoryValue()" [description]="'T_DELETE_ACCESSORY_VALUE_MODAL_MESSAGE' | translate"
                  [name]="'deleteAccessoryValueModal'" >
</app-common-modal>
